import { invalidateLocationQueries } from '@/lib/locations/invalidate';
import { createMutationHook } from '@/hooks/lib/createMutationHook';
import { apiPatch, operationsClient } from '@/lib/api';
import { opsProposalEndpoints } from '@/lib/api/endpoints';
import { opsProposalKeys } from '@/lib/queryKeys';
import type { Proposal, UpdateProposalDto } from '@/types/proposal';

/**
 * Updates an existing proposal via the operations microservice.
 */
export const useUpdateProposal = createMutationHook<
  Proposal,
  { id: string; dto: UpdateProposalDto }
>({
  mutationFn: ({ id, dto }) =>
    apiPatch<Proposal, UpdateProposalDto>(operationsClient, opsProposalEndpoints.update(id), dto),
  onSuccess: (data, _variables, queryClient) => {
    // A typed service address is saved to the customer as a location on the
    // server, so this save may have created one. See `invalidateLocationQueries`.
    invalidateLocationQueries(
      queryClient,
      (data as { contactId?: string | null; customer?: { contactId?: string | null } }).contactId ??
        (data as { customer?: { contactId?: string | null } }).customer?.contactId,
    );
    void queryClient.invalidateQueries({ queryKey: opsProposalKeys.lists() });
    void queryClient.invalidateQueries({ queryKey: opsProposalKeys.detail(data.id) });
  },
});
